import logo from "assets/images/logo-bn.png";
import { XCircle } from "react-bootstrap-icons";
import { PrimaryButton } from "../../../../components/buttons/buttons";
import Modal from "../../../../components/modals/modal/modal";
import { MessageModalProps } from "../../../../core/utils/modals";
import "./pago-rechazado.modal.scss";

const footer = (close: VoidFunction) => (
	<PrimaryButton onClick={close}>Cerrar</PrimaryButton>
);

export const PagoRechazadoModal = (props: MessageModalProps) => {
	return (
		<Modal parent={props.parent} dialogClassName="pago-rechazado" footer={footer} onClosed={props.onClosed}>
			<div className="col-12" >
				<div className="comprobante-banorte">
					<div className="c-header">
						<img src={logo} alt="alt" height="60px" />
					</div>
					<div className="c-body">
						<div className="c-b-error">
							<div className="e-title">
								<span>El pago no ha sido autorizado</span>
							</div>
							<div className="e-icon">
								<XCircle height="80" width="80"></XCircle>
							</div>
							<div className="e-error">
								<span>{props.message}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Modal>
	);
};

export default PagoRechazadoModal;